import { render, staticRenderFns } from "./AddUserType.vue?vue&type=template&id=2ca38ce8&scoped=true"
import script from "./AddUserType.vue?vue&type=script&lang=js"
export * from "./AddUserType.vue?vue&type=script&lang=js"
import style0 from "./AddUserType.vue?vue&type=style&index=0&id=2ca38ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca38ce8",
  null
  
)

export default component.exports